import { Tooltip as MuiToolTip, TooltipProps } from '@mui/material'
import {
  CheckIcon,
  CorrectionIcon,
  DeniedIcon,
  EyeIcon,
  InfoIcon,
  LeafFillIcon,
  WarningIcon,
} from '~components/icons'
import { COLORS } from '~theme/colors'

export type IconOptions =
  'warning' | 'denied' | 'confirm' | 'info' | 'eye' | 'correction' | 'fuel-eu'

export function Tooltip(
  props: Omit<TooltipProps, 'children'> & {
    icon?: IconOptions
    labelText?: string | React.ReactNode
    size?: number
    color?: string
    style?: React.CSSProperties
    children?: React.ReactNode
  },
) {
  const size = props.size || 16
  const incomingSlotProps = (props.slotProps || {}) as TooltipProps['slotProps']
  const tooltipSx = {
    bgcolor: COLORS.primary.white,
    boxShadow: '0px 4px 24px 8px rgba(0, 0, 0, 0.08)',
    ...(incomingSlotProps?.tooltip as any)?.sx,
  }
  const arrowSx = {
    color: COLORS.primary.white,
    ...(incomingSlotProps?.arrow as any)?.sx,
  }
  const mergedSlotProps: TooltipProps['slotProps'] = {
    ...(incomingSlotProps || {}),
    tooltip: {
      ...(incomingSlotProps?.tooltip || {}),
      sx: tooltipSx,
    },
    arrow: {
      ...(incomingSlotProps?.arrow || {}),
      sx: arrowSx,
    },
  }
  const {
    labelText,
    icon,
    size: _size,
    color,
    style,
    slotProps,
    children,
    ...rest
  } = props

  return (
    <MuiToolTip
      enterTouchDelay={0}
      placement={props.placement || 'bottom'}
      slotProps={mergedSlotProps}
      {...(rest as TooltipProps)}
    >
      <div
        style={{
          color: COLORS.secondary.midBlue,
          fontSize: 12,
          marginTop: !!labelText ? '12px' : 0,
          lineHeight: '16px',
          cursor: 'pointer',
          ...style,
        }}
      >
        {labelText ??
          (icon === 'denied' ? (
            <DeniedIcon size={size - 1} color={color || COLORS.red.dark} />
          ) : icon === 'confirm' ? (
            <CheckIcon size={size} color={color || COLORS.secondary.midBlue} />
          ) : icon === 'warning' ? (
            <WarningIcon
              size={size}
              color={color || COLORS.secondary.darkBlue}
            />
          ) : icon === 'eye' ? (
            <EyeIcon size={size} color={color || COLORS.primary.white} />
          ) : icon === 'correction' ? (
            <CorrectionIcon
              size={size}
              color={color || COLORS.secondary.darkBlue}
            />
          ) : icon === 'fuel-eu' ? (
            <LeafFillIcon size={size} />
          ) : !children ? (
            <InfoIcon size={size} color={color || COLORS.secondary.darkBlue} />
          ) : (
            children
          ))}
      </div>
    </MuiToolTip>
  )
}
